module.exports = __webpack_public_path__ + "static/media/eye_crossed.88fbbf5b.svg";